import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { assignDeviceToCustomer } from '../../pages/Device/DeviceSlice';
import { useTranslation } from 'react-i18next';

const ModalTransferCustomer = ({ setShow, show, deviceId }) => {
  const handleClose = () => setShow(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();

  const token = localStorage.getItem('token');
  const [validated, setValidated] = useState(false);
  const dataCustomers = useSelector((state) => state.customers.customers);
  const allCustomerName = dataCustomers.data?.map((item) => ({
    name: item.name,
    id: item.id,
  }));

  const customerId = location.pathname.slice(
    location.pathname.lastIndexOf('/') + 1
  );
  const [newCustomerId, setNewCustomerId] = useState(customerId);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    dispatch(
      assignDeviceToCustomer({
        token,
        newCustomerId,
        deviceId,
      })
    );
    setShow(false);
    setValidated(false);
  };
  return (
    <Modal onHide={handleClose} show={show}>
      <Modal.Header closeButton>
        <Modal.Title>
          {t('customer-transfer') /*Chuyển Đổi Khách Hàng */}
        </Modal.Title>
      </Modal.Header>
      <Form noValidate validated={validated}>
        <Modal.Body>
          <Form.Group as={Col} controlId="customerId">
            <Form.Label>{t('device-id') /*ID Thiết Bị */}:</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Tên khách hàng"
              disabled
              value={deviceId}
            />
          </Form.Group>
          <Form.Group as={Col} controlId="email">
            <Form.Label>{t('customer') /*Khách Hàng*/}:</Form.Label>
            <Form.Select
              defaultValue={customerId}
              onChange={(e) => setNewCustomerId(e.target.value)}
            >
              {allCustomerName?.map((item, index) => (
                <option value={item.id.id} key={index}>
                  {item.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t('close')}
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            {t('update')}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ModalTransferCustomer;
